<template>
  <div v-if="isView" class="cont" :class="{proxy: $config.proxyServer}">
    <span v-if="$config.isLocalDevelopmentServer" >
      <span style="opacity: .7;">FE 로컬개발서버 - API : </span><b>{{$config.proxyServer ? $config.proxyServer : 'mockup 데이터'}}</b>
    </span>
    <span v-else>Menu</span>
    <div class="menu">
      <router-link to="/news">소식톡톡 일반소식</router-link>
      <router-link to="/repeat_news">소식톡톡 반복소식</router-link>
      <router-link to="/health">건강백세</router-link>
      <router-link to="/analytics">통계</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isView: /localhost/.test(window.location.host)
    }
  }
}
</script>

<style scoped>
.cont {
  position: absolute;
  top: 0;
  left: 0;
  background: darkred;
  opacity: .7;
  color: white;
  padding: 5px;
}

.proxy {
  background: green;
}

.menu a {
  margin-right: 10px;
  color: LightSkyBlue;
}

</style>
